import React from 'react';
import TeamForm from '../../../../components/forms/TeamForm';

export default function InstitutionTeamsCreatePage() {
  return <TeamForm />;
}
